import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import './ChangePassword.css';
import API_URL from "./Config";
const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rePasswordError, setRePasswordError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "currentPassword") {
      setCurrentPassword(value);
      setCurrentPasswordError("");
    } else if (name === "newPassword") {
      setNewPassword(value);
      setPasswordError("");
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
      setRePasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password and email validation regular expression
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    // Reset any previous error messages
    setMessage("");
    setError("");
    setCurrentPasswordError("");
    setPasswordError("");
    setRePasswordError("");

    if (currentPassword === "") {
      setCurrentPasswordError("Current Password is required");
      return;
    }

    if (newPassword === "") {
      setPasswordError("New Password is required");
      return;
    }

    if (confirmPassword === "") {
      setRePasswordError("Please re-enter your password");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      setError(
        "Password must contain at least 8 characters, including one lowercase letter, one uppercase letter, one digit, and one special character (@$!%*?&)"
      );
      return;
    }

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await fetch(
        `${API_URL}/api/change-password`,
        {
          method: "POST",
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            current_password: currentPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
          }), // Include confirm_password in the request
        }
      );

      if (response.ok) {
        setMessage("Password changed successfully");
        setError("");
      } else {
        const data = await response.json();
        setMessage("");
        setError(data.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setMessage("");
      setError("An error occurred while changing the password");
    }
  };

  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <title>Change Password</title>
        </Helmet>
      </HelmetProvider>
      <div className="changepassword-container">
        <div className="changepassword-contant">
        {/* <div className="changepassword-image">
         <a href="/datalist"><img src="/logo100.png" alt="Logo" className="changepassword-logo" /></a>
        </div> */}
          <div className="changepassword">
            <div className="card-body">
              <h3 className="changepassword-card">Change Password</h3>

              <p className="small-font">
                {message && (
                  <span style={{ fontSize: "16px", color: "rgb(219, 38, 38)" }}>
                    {message}
                  </span>
                )}
                {error && (
                  <span style={{ fontSize: "16px", color: "rgb(219, 38, 38)" }}>
                    {error}
                  </span>
                )}
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="changepassword">
                    <span className="text-danger">*</span> Current Password
                  </label>
                  <input
                    type="password"
                    name="currentPassword"
                    className={`form-control ${
                      currentPasswordError ? "is-invalid" : ""
                    }`}
                    placeholder="Enter current password"
                    value={currentPassword}
                    onChange={handleChange}
                    required
                  />
                  {currentPasswordError && (
                    <div className="invalid-feedback">
                      {currentPasswordError}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label className="changepassword">
                    <span className="text-danger">*</span> New Password
                  </label>
                  <input
                    type="password"
                    name="newPassword"
                    className={`form-control ${
                      passwordError ? "is-invalid" : ""
                    }`}
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={handleChange}
                    required
                  />
                  {passwordError && (
                    <div className="invalid-feedback">{passwordError}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="changepassword">
                    <span className="text-danger">*</span> Confirm Password
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    className={`form-control ${
                      rePasswordError ? "is-invalid" : ""
                    }`}
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  {rePasswordError && (
                    <div className="invalid-feedback">{rePasswordError}</div>
                  )}
                </div>

                <button type="submit" className="continue2">
                  Change Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;